export default function closeEditMode(block: HTMLElement) {
	const findHtmlEl = pm.utils.dom.findHtmlEl;

	block.classList.remove("is-editing");

	const triggerButton = findHtmlEl(block, ".inline-edit-button");
	triggerButton?.parentElement?.classList.remove("is-hidden");

	const actionButtonsWrapper = findHtmlEl(block, ".action-buttons");
	actionButtonsWrapper?.classList.add("is-hidden");

	const errorMessageEl = findHtmlEl(block, ".wpbf-notice-error");

	if (errorMessageEl) {
		errorMessageEl.classList.add("is-hidden");
	}

	const contentWrapper = findHtmlEl(block, ".content-wrapper");

	if (contentWrapper) {
		contentWrapper.classList.remove("is-hidden");
	}

	const editor = findHtmlEl(block, ".content-editor");

	if (editor) {
		const suffixEl = findHtmlEl(block, ".field-suffix");

		editor.classList.add("is-hidden");
		if (suffixEl) suffixEl.classList.add("is-hidden");
	}
}
